import { Images } from 'utils';

export const DeleteWithIcon = ({ handleClick }) => {
    return (
        <button className="delete-btn-with-icon-box" onClick={handleClick}>
            <img src={Images.redTrash} alt="" />
        </button>
    );
};
